
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/founder-profile",
      function () {
        return require("private-next-pages/founder-profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/founder-profile"])
      });
    }
  